export default __webpack_public_path__ + "static/media/need_something.c81b8e13.png";